import { Skeleton } from '@mui/material';

const SummaryListSkeleton = () => {
  return (
    <div className='flex flex-col gap-4'>
      {[1, 2, 3].map((i) => (
        <div key={i} className='p-6 bg-white rounded-2xl border border-gray-100 flex flex-col md:flex-row gap-6'>
          <Skeleton variant="rounded" width={200} height={80} className="rounded-xl" />
          <div className="flex-1 space-y-2">
            <Skeleton variant="text" width="40%" height={24} />
            <Skeleton variant="text" width="60%" height={20} />
          </div>
          <Skeleton variant="rounded" width={120} height={40} className="rounded-full" />
        </div>
      ))}
    </div>
  );
};

export default SummaryListSkeleton;
